(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-about"]) return;
  try {
    
$(function(){
$(".mainvisual").addClass("fadeBlur");
$(".copy").addClass("fadeUp");
if(window.innerWidth > 641){

}

$(window).scroll(function (){

    var scroll = window.pageYOffset;
    var windowHeight = $(window).height();

    if(window.innerWidth >= 641){
        $('.section-1__inner').addClass('fadeUp');
    }

    $('.about').find(".fade2").addClass("fadeUp");

    $('.fade').each(function(){
      var elemPosFade = $(this).offset().top;
      if (scroll > elemPosFade - windowHeight * 0.8){
            $(this).addClass('fade-active');
      }
});



$('.about').find('.section-2__imgWrap:not(".section-2__imgWrap--no-parallax")').each(function(){
var elemPosImg = $(this).offset().top;
var copyHeight = $('.copy-2').height();
var translateY = "translateY(" + copyHeight + "px)";

if (scroll > elemPosImg - windowHeight && window.innerWidth > 641){
//ポートレートの視差効果（PCのみ）
$(this).children('.section2__img').css('top', ( -50 - (scroll - elemPosImg) / 9) + 'px');
}

});


});


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-concept"]) return;
  try {
    
$(function(){
  	$(".mainvisual").addClass("fadeBlur");
	$(".copy").addClass("fadeUp"); 
  
  
  $(window).scroll(function (){
    
    var scroll = window.pageYOffset;
    var windowHeight = $(window).height();
    

    $('.fade').each(function(){
        var elemPosFade = $(this).offset().top;
        if (scroll > elemPosFade - windowHeight * 0.8){
            $(this).addClass('fade-active');
        }
    });
  
   

    
    $('.concept').find('.section-2__imgWrap').each(function(){
        var elemPosImg = $(this).offset().top;
      	var copyHeight = $('.copy-2').height();
      	var translateY = "translateY(" + copyHeight + "px)";
      
        if (scroll > elemPosImg - windowHeight && window.innerWidth > 641){
          //ポートレートの視差効果（PCのみ）
           $(this).children('.section2__img').css('top', (  -100 - (scroll - elemPosImg) / 8 * 1.1) + 'px');
        }
      
    });
    
    
 });
  
  
});

  } catch(e) { console.error(e); }
})();
})();
